export default function Cube() {
  return (
    <div
      className="ion-icon-cube"
      dangerouslySetInnerHTML={{
        __html: `<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.2.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="512px" height="512px" viewBox="0 0 512 512" enable-background="new 0 0 512 512" xml:space="preserve">
<g>
	<path d="M467.301,168.084c-1.805,0-3.516,0.329-5.07,0.962l-2.281,1.15l-171.475,88.938l-3.888,1.996c0,0-0.052,0.023-0.052,0.047
		c-7.56,4.668-12.535,12.506-12.535,21.425v185.854c0,6.382,5.649,11.544,12.69,11.544c2.178,0,4.251-0.513,6.065-1.404
		c0.155-0.095,0.363-0.188,0.519-0.282l174.731-92.694l0.259-0.141c8.241-4.504,13.735-12.742,13.735-22.105V179.582
		C480,173.223,474.299,168.084,467.301,168.084z"/>
	<path d="M454.273,118.521l-181.7-81.731c0,0-10.659-4.79-16.577-4.79s-16.526,4.79-16.526,4.79L57.614,118.521
		c0,0-7.989,3.292-7.989,9.479c0,6.562,8.3,11.5,8.3,11.5l182.582,96.371l2.902,1.479c3.784,1.687,8.077,2.649,12.587,2.649
		c4.561,0,8.915-0.963,12.742-2.696l2.539-1.315l182.893-96.536c0,0,7.508-4.036,7.508-11.453
		C461.678,121.5,454.273,118.521,454.273,118.521z"/>
	<path d="M227.466,261.178l-3.992-2.043L52.042,170.197l-2.28-1.15c-1.495-0.634-3.258-0.962-5.071-0.962
		c-6.997,0-12.69,5.138-12.69,11.497v183.792c0,9.388,5.485,17.602,13.727,22.105l0.208,0.141l174.739,92.694l0,0
		c1.918,1.08,4.199,1.687,6.636,1.687c6.989,0,12.69-5.162,12.69-11.544V282.603C240,273.684,235.024,265.846,227.466,261.178z"/>
</g>
</svg>
`,
      }}
    />
  )
}
